import { useState, useEffect, useCallback, useRef } from "react";

import openSocket from "../../services/socket-io";
import api from "../../services/api";

/**
 * Shared billing state: the sidebar, the banner and the billing page all need
 * the same answer, and all of them must survive the endpoint being unreachable
 * without breaking their own render.
 */
const useBillingStatus = () => {
  const isMounted = useRef(true);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => () => { isMounted.current = false; }, []);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/status");
      if (isMounted.current) setStatus(data);
    } catch {
      // Billing must never take down the layout that hosts it.
      if (isMounted.current) setStatus(null);
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    const socket = openSocket();
    const handleBilling = () => reload();
    socket.on("billing", handleBilling);
    return () => socket.off("billing", handleBilling);
  }, [reload]);

  return { status, loading, reload };
};

export default useBillingStatus;
